/** @format */
import { css } from 'styled-components';

import { SignUpConfirmationPendingStyleProps } from './index';

/**
 * Base styles for the sign up confirmation pending component
 *
 * @param {SignUpConfirmationPendingStyleProps} props The sign up confirmation pending properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: SignUpConfirmationPendingStyleProps) => css`
    text-align: left;

    .heading,
    .hero-image {
        text-align: center;
    }

    .hero-svg {
        width: 12rem;
    }
`;

/**
 * The sign up confirmation pending component styles
 *
 * @param {SignUpConfirmationPendingStyleProps} props The sign up confirmation pending properties object
 * */
export const styles = (props: SignUpConfirmationPendingStyleProps) => css`
    ${baseStyles(props)}
`;
